<div class="container">
  @if (customer(); as resolvedCustomer) {
    @if (user(); as resolvedUser) {
      <app-account-settings-brand-settings [customer]="resolvedCustomer" [user]="resolvedUser"></app-account-settings-brand-settings>
    }
  }
</div>
